import { inject, Injectable } from '@angular/core';

import { ApiService } from '@core/services';
import { ROUTES } from '@core/constants';
import {
  CreateVehicleBrrandPayload,
  IResponseHttp,
  IRoleCatalog,
  ServiceCategoryOption,
  VehicleVersionData,
} from '@core/models';

@Injectable({
  providedIn: 'root',
})
export class CatalogService {
  readonly api = inject(ApiService);

  async createVehicleBrand(
    payload: CreateVehicleBrrandPayload,
  ): Promise<VehicleVersionData> {
    const result = await this.api.post<IResponseHttp>(
      ROUTES.CATALOG_CREATE_VEHICLE_BRAND,
      payload,
    );
    return result.payload.vehicle;
  }

  async getRoles(): Promise<IRoleCatalog[]> {
    const result = await this.api.get<IResponseHttp>(ROUTES.CATALOG_GET_ROLES);
    return result.payload;
  }

  async getServiceCategories(): Promise<ServiceCategoryOption[]> {
    const response = await this.api.get<IResponseHttp>(ROUTES.CATALOG_SERVICE_CATEGORIES);
    return response?.payload;
  }

  async createCatalogService(payload: {
    categoryId: string;
    name: string;
    vehicleVersionId: string;
    price: string;
  }): Promise<IResponseHttp> {
    const response = await this.api.post<IResponseHttp>(ROUTES.CATALOG_SERVICES, payload);
    return response;
  }

  async updateCatalogService(payload: {
    id: string;
    categoryId: string;
    name: string;
    vehicleVersionId: string | null;
    price: string;
  }): Promise<IResponseHttp> {
    const { id, ...rest } = payload;
    const response = await this.api.patch<IResponseHttp>(
      ROUTES.CATALOG_UPDATE_SERVICES(id),
      rest,
    );
    return response;
  }
}
